import React from "react";
import { motion } from "framer-motion";
import { Box, Button, Container, Grid, Typography } from "@mui/material";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { brand, promoBanner } from "../data/estoreContent";
import { ESTORE_ROUTES } from "../data/estorePaths";

function EstorePromo() {
  const navigate = useNavigate();

  return (
    <Box sx={{ py: { xs: 5, md: 7 } }}>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={0}
          component={motion.div}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.55 }}
          sx={{
            borderRadius: { xs: 3, md: 4 },
            overflow: "hidden",
            border: `1px solid ${brand.stroke}`,
            bgcolor: "#0F172A",
          }}
        >
          <Grid item xs={12} md={6} sx={{ minHeight: { xs: 260, md: 320 }, overflow: "hidden" }}>
            <motion.img
              src={promoBanner.image}
              alt=""
              initial={{ scale: 1.08 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
              style={{
                width: "100%",
                height: "100%",
                minHeight: 260,
                objectFit: "cover",
                display: "block",
              }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              p: { xs: 3, md: 5 },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography variant="overline" sx={{ color: "rgba(255,255,255,0.55)", letterSpacing: "0.18em", fontWeight: 700 }}>
              Limited window
            </Typography>
            <Typography variant="h4" sx={{ color: "#fff", fontWeight: 800, mt: 1, letterSpacing: "-0.02em" }}>
              {promoBanner.title}
            </Typography>
            <Typography variant="body1" sx={{ color: "rgba(255,255,255,0.78)", mt: 2, lineHeight: 1.7, maxWidth: 440 }}>
              {promoBanner.subtitle}
            </Typography>
            <Box sx={{ mt: 3 }}>
              <Button
                variant="contained"
                endIcon={<ArrowRight size={18} />}
                onClick={() => navigate(ESTORE_ROUTES.shop)}
                sx={{
                  borderRadius: 999,
                  px: 3,
                  py: 1.25,
                  fontWeight: 800,
                  textTransform: "none",
                  bgcolor: "#fff",
                  color: brand.text,
                  "&:hover": { bgcolor: "rgba(255,255,255,0.92)" },
                }}
              >
                {promoBanner.cta}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default EstorePromo;
